import { createSlice } from "@reduxjs/toolkit";
import {         support_getCategoriesThunk  } from "./thunk";


// slice for business point in home dashboard

export const initialState = {
  supportCategoriesData: [],
  supportCategoriesError: '', // for error message
  supportCategoriesLoading: false,
  
  
};

const Support_Get_Categories = createSlice({
  name: "Support_Get_Categories",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(support_getCategoriesThunk.pending, (state) => {
      state.supportCategoriesLoading = true ;
      state.supportCategoriesData = [];
      state.supportCategoriesError = '';
  });
    builder.addCase(support_getCategoriesThunk.fulfilled, (state, action) => {
        state.supportCategoriesData = action.payload.data;
        state.supportCategoriesLoading = false ;
    });
    builder.addCase(support_getCategoriesThunk.rejected, (state, action) => {
      state.supportCategoriesError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.supportCategoriesLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  Support_Get_Categories_Success,
  
} = Support_Get_Categories.actions

export default Support_Get_Categories.reducer;


